import { WorkflowList } from '@/originator/WorkflowList';

/** Originator dashboard. User identity / sign-out / role live in the app header. */
export function OriginatorDashboard() {
  return <WorkflowList />;
}
